import React from 'react';
import { Drawer, Button, Col, Row, Input, notification } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { Form } from '@ant-design/compatible';

class DrawerMercadoPago extends React.Component {
  state = { visible: false, childrenDrawer: false };

  onClose = () => {
    this.props.ocultarDrawer();
  };

  onSubmitSinStock = () => {
    let numeroComprobante = this.props.form.getFieldValue('numeroComprobante');
    if (numeroComprobante && numeroComprobante.length > 0) {
      this.props.onFinalizarSinStock(numeroComprobante);
    } else {
      if (!numeroComprobante || numeroComprobante.length < 1) {
        notification.error({
          message: 'ERROR REFERENTE AL NUMERO DE COMPROBANTE.',
          description: ' VERIFIQUE QUE ESTE EXISTA Y ESTE BIEN CARGADO.',
        });
      }
    }
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div>
        <Drawer
          title="Otros datos"
          width={420}
          onClose={this.onClose}
          visible={this.props.visible}
        >
          <Form layout="vertical" hideRequiredMark>
            <Row gutter={16}>
              <Col span={20}>
                <Form.Item label="Numero de comprobante">
                  {getFieldDecorator('numeroComprobante', {
                    rules: [
                      {
                        required: true,
                        message: 'Ingrese el numero de Comprobante',
                      },
                    ],
                  })(
                    <Input
                      onPressEnter={this.onSubmitSinStock}
                      placeholder="Por favor, ingresar el numero de comprobante"
                    />
                  )}
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <div
            style={{
              position: 'absolute',
              left: 0,
              bottom: 0,
              width: '100%',
              borderTop: '1px solid #e9e9e9',
              padding: '10px 16px',
              background: '#fff',
              textAlign: 'right',
            }}
          >
            <Button onClick={this.onClose} style={{ marginRight: 8 }}>
              Cancelar
            </Button>
            <Button
              onClick={this.onSubmitSinStock}
              disabled={!this.props.crearVentaCompleta}
              type="primary"
              style={{ marginTop: 10, marginLeft: 5 }}
            >
              <Icons.CreditCardOutlined />
              Generar Venta
            </Button>
          </div>
        </Drawer>
      </div>
    );
  }
}

export default Form.create()(DrawerMercadoPago);
